var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookingTickets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49984 11.6667C2.49984 10.7462 3.24603 9.99999 4.1665 9.99999H36.6665C37.587 9.99999 38.3332 10.7462 38.3332 11.6667V28.3333C38.3332 29.2538 37.587 30 36.6665 30H4.1665C3.24603 30 2.49984 29.2538 2.49984 28.3333V11.6667Z",
    stroke: "#2E2E2E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.14062 23.6272C5.3758 23.8026 8.58774 25.5231 8.45992 29.6802",
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2266 23.6272C35.9914 23.8026 32.7794 25.5231 32.9073 29.6802",
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2266 16.053C35.9914 15.8776 32.7794 14.1571 32.9073 9.99996",
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.14062 16.053C5.37581 15.8776 8.58774 14.1571 8.45992 9.99996",
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 13.3333L15.8335 26.6667",
    stroke: "currentColor",
    strokeWidth: 1.66667
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.6665,
    cy: 15,
    r: 1.66667,
    stroke: "currentColor",
    strokeWidth: 1.66667
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 24.1667,
    r: 1.66667,
    stroke: "currentColor",
    strokeWidth: 1.66667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingTickets);
export default __webpack_public_path__ + "static/media/Booking & Tickets.29e093a1d0e4b3771b8dedf853c13e57.svg";
export { ForwardRef as ReactComponent };